import React, { useCallback, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Context } from 'components/Store';
import MassAssignerTree from './components/MassAssignerTree';
import DefaultTree from './components/DefaultTree';
import PropertyLandingContext from '../../context';
import ExportPDFMapsOptionsForm from './components/ExportPDFMapsOptionsForm';
import SearchLoading from './components/SearchLoading';
import SelectedPropertyContext from '../SelectedPropertyContext';
import { filterPropertiesBySearchText } from '../../helpers/propertyFilters';

const propertyTreeViewDefaultPropProperties = [];
const propertyTreeViewDefaultPropRawProperties = [];
const PropertyTreeView = ({
  properties = propertyTreeViewDefaultPropProperties,
  rawProperties = propertyTreeViewDefaultPropRawProperties,
  searchResults
}) => {
  const {
    isHugeOrganization,
    fieldsAndAreasGeoJSONCollection,
    isLoadingPaginatedProperties
  } = useContext(PropertyLandingContext);
  const [
    {
      isMassAssignerActive,
      fieldsToMassiveAssign,
      isExportPDFMapsActive,
      exportPDFMapsStep,
      isSortByCrop,
      searchTextValueFFT: searchTerm,
      selectedProperty,
      expandedPropertyIds,
      loggedInUserOrgPermission,
      updateCropName
    },
    dispatch
  ] = useContext(Context);

  const selectedPropertyCtx = useMemo(
    () => ({
      selectedPropertyId: selectedProperty?.id,
      updateCropName,
      dispatch
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selectedProperty?.id, updateCropName]
  );

  const propertiesFilter = useCallback(
    (obj, searchTextValueFFT) => {
      if (isHugeOrganization) return obj;
      return filterPropertiesBySearchText(
        obj,
        searchTextValueFFT?.valueInput || ''
      );
    },
    [isHugeOrganization]
  );

  if (isLoadingPaginatedProperties && searchTerm?.valueInput) {
    return <SearchLoading />;
  }

  if (
    isMassAssignerActive ||
    (isExportPDFMapsActive && exportPDFMapsStep === 0)
  ) {
    return (
      <MassAssignerTree
        properties={properties}
        fieldsAndAreasGeoJSONCollection={fieldsAndAreasGeoJSONCollection}
        propertiesFilter={propertiesFilter}
        fieldsToMassiveAssign={fieldsToMassiveAssign}
        searchTextValueFFT={searchTerm}
        isExportPDFMapsActive={isExportPDFMapsActive}
        isSortByCrop={isSortByCrop}
        dispatch={dispatch}
      />
    );
  }
  if (isExportPDFMapsActive && exportPDFMapsStep === 1) {
    return <ExportPDFMapsOptionsForm selectedFields={fieldsToMassiveAssign} />;
  }
  return (
    <SelectedPropertyContext.Provider value={selectedPropertyCtx}>
      <DefaultTree
        properties={searchResults ?? properties}
        rawProperties={rawProperties}
        propertiesFilter={searchResults ? obj => obj : propertiesFilter}
        selectedPropertyId={selectedProperty?.id}
        expandedPropertyIds={expandedPropertyIds}
        loggedInUserOrgPermission={loggedInUserOrgPermission}
        searchTextValueFFT={searchTerm}
        dispatch={dispatch}
      />
    </SelectedPropertyContext.Provider>
  );
};

PropertyTreeView.propTypes = {
  properties: PropTypes.arrayOf(PropTypes.object),
  rawProperties: PropTypes.arrayOf(PropTypes.object),
  searchResults: PropTypes.arrayOf(PropTypes.object)
};

export default PropertyTreeView;
